// test2044
(2044 && 0);
